{
  "riley": [
    {
      "text": "Training",
      "file": "word-riley-training.svg",
      "width": 299.983,
      "height": 140
    },
    {
      "text": "the",
      "file": "word-riley-the.svg",
      "width": 128.812,
      "height": 140
    },
    {
      "text": "Idea",
      "file": "word-riley-idea.svg",
      "width": 187.768,
      "height": 140
    },
    {
      "text": "Muscle",
      "file": "word-riley-muscle.svg",
      "width": 229.632,
      "height": 140
    },
    {
      "text": "ZINE",
      "file": "word-riley-zine.svg",
      "width": 213.035,
      "height": 140
    }
  ],
  "farza": [
    {
      "text": "You",
      "file": "word-farza-you.svg",
      "width": 152.954,
      "height": 140
    },
    {
      "text": "can",
      "file": "word-farza-can.svg",
      "width": 160.206,
      "height": 140
    },
    {
      "text": "make",
      "file": "word-farza-make.svg",
      "width": 190.203,
      "height": 140
    },
    {
      "text": "something",
      "file": "word-farza-something.svg",
      "width": 298.655,
      "height": 140
    },
    {
      "text": "good",
      "file": "word-farza-good.svg",
      "width": 180.643,
      "height": 140
    },
    {
      "text": "ZINE",
      "file": "word-farza-zine.svg",
      "width": 193.499,
      "height": 140
    }
  ]
}
